import "../../../Index.scss";
import DocumentIntro from "../DocumentIntro/DocumentIntro";

export const PraticeSearchResult = ({practiceItem, index, onClickPreview, onClickReadMore, getQuikInfoData, setActiveIndex, activeIndex}:any) => {
    return (
      <div className="group-list" key={`PracticeSearchResult${index}`}>
            <div className="group-list-head">
                <span className="group-list-title">
                    <ul className="group-list-places">
                        <li>
                            <img
                                className="group-list-icon logoicon"
                                src={'https://cdn.taxmann.com/taxmann-images/taxmann-premium/practice-icon-n1.png'}
                            ></img>
                        </li>
                        <li>{practiceItem.Index}</li>
                        <li><i className="pi pi-angle-right"></i></li>
                        <li>{practiceItem?.categoryName}</li>
                        <li><i className="pi pi-angle-right"></i></li>
                        <li>{practiceItem?.globaltopic}</li>
                        <li><i className="pi pi-angle-right"></i></li>
                        <li>{practiceItem?.groupName}</li>
                    </ul>
                </span>
                <DocumentIntro item={practiceItem} index={index} getQuikInfoData={getQuikInfoData} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
            </div>
            <div className="group-list-contents">
                <div className="group-row">
                    <div className="list-items">
                        <div className="list-item-contents">
                            <h2 className="list-item-h2 pointer" onClick={() => onClickPreview(practiceItem)}>
                                {practiceItem?.secondLine}
                                {/* {practiceItem?.heading1 && `, ${practiceItem?.heading1}`} */}
                            </h2>
                            <span className="list-item-description pointer">
                                {practiceItem?.shortIntroduction || practiceItem?.thirdLine}
                                
                                {practiceItem?.thirdLine?.length > 330 && (
                                    practiceItem?.showReadMore ? (
                                    <a
                                        className="button-links cursor-pointer"
                                        onClick={() => onClickReadMore(practiceItem, index)}
                                    >
                                        Read More
                                    </a>
                                    ) : (
                                    <a
                                        style={{ marginLeft: '10px' }}
                                        className="button-links cursor-pointer"
                                        onClick={() => onClickReadMore(practiceItem, index)}
                                    >
                                        Read Less
                                    </a>
                                    )
                                )}
                                </span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PraticeSearchResult


 